import gql from 'graphql-tag'

export const createOrUpdateContactInfoMutation = gql`
  mutation createOrUpdateContactInformation($expertId: String!, $input: ContactInformationInput!) {
    createOrUpdateContactInformation(expertId: $expertId, input: $input)
  }
`

export const saveUserPhoneNumberMutation = gql`
mutation createOrUpdatePhoneNumber($id: Int!, $phoneNumber: String!) {
  createOrUpdatePhoneNumber(id: $id, phoneNumber: $phoneNumber)
}
`

